import { useState } from "react";
import { Button, ListItem, Stack, Typography } from "@mui/material";
import type { CoachingWorkspaceItem } from "@bw/shared/api";
import { CoachingProposalPanel } from "./CoachingProposalPanel";
import { CoachingLessonPanel } from "./CoachingLessonPanel";

export function LessonRow({ item }: { item: CoachingWorkspaceItem }) {
  const [view, setView] = useState<"proposal" | "lesson" | null>(null);
  return <ListItem divider sx={{ display: "block", p: 2 }}>
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ justifyContent: "space-between" }}>
      <Typography sx={{ fontWeight: 700 }}>{item.title}</Typography>
      <Stack direction="row" spacing={1}>
        {item.can_view_proposal && item.revision_id ? <Button size="small" onClick={() => setView("proposal")}>Review proposal</Button> : null}
        {item.can_view_lesson && item.acceptance_id ? <Button size="small" onClick={() => setView("lesson")}>View lesson</Button> : null}
      </Stack>
    </Stack>
    {item.historical_status ? <Typography variant="body2">{item.historical_status === "paid" ? "Paid — read-only history" : "Completed — read-only history"}</Typography>
      : item.proposal_state === "none" && !item.can_view_lesson ? <Typography color="text.secondary" variant="body2">Awaiting a proposal</Typography> : null}
    {view === "proposal" && item.can_view_proposal && item.revision_id ? <CoachingProposalPanel requestId={item.request_id} revisionId={item.revision_id} /> : null}
    {view === "lesson" && item.can_view_lesson && item.acceptance_id ? <CoachingLessonPanel acceptanceId={item.acceptance_id} /> : null}
  </ListItem>;
}
